// @flow

import { setCheckedItemPaths } from '../State/checkedItemPaths';
import selectListItems from '../Selectors/selectListItems';

export default () => (dispatch: Function, getState: Function) => {

  const state = getState();
  const listItems = selectListItems(state);
  const { checkedItemPaths } = state.screens.ProjectView;

  // If all items are checked, uncheck all. Otherwise, check all.
  const allPaths = listItems.map(item => item.path);
  const allChecked = allPaths.length > 0 && allPaths.every(path => checkedItemPaths.includes(path));

  if (allChecked) {
    // Uncheck all
    dispatch(setCheckedItemPaths([]));
  } else {
    // Check all
    dispatch(setCheckedItemPaths(allPaths));
  }

}
